import { isDefined } from "@omni/utils/helper.utils";

import { AutocompleteAddress } from "@/services/bpost.service";

const getCursorPosition = (address: AutocompleteAddress | null) => {
    if (!isDefined(address)) return 0;

    if (address.listOfBoxes && address.houseNumber) {
        const boxRegex = / (bus|bte) /i;
        const boxIndex = address.searchBarString.match(boxRegex)?.index ?? 0;

        return boxIndex + 5;
    } else if (address.streetName) {
        return address.streetName.length + 1;
    }

    return 0;
};

type UpdateCursorPositionProps = {
    address: AutocompleteAddress | null;
    inputField: HTMLInputElement | null;
    openMenu: () => void;
};

export const updateCursorPosition = ({
    address,
    inputField,
    openMenu
}: UpdateCursorPositionProps) => {
    if (address?.isComplete) return;

    const cursorPosition = getCursorPosition(address);
    inputField?.setSelectionRange(cursorPosition, cursorPosition);

    inputField?.focus();
    openMenu();
};
